import { Component } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { FullPageMaskService } from '../../services/full-page-mask.service';

@Component({
  selector: 'com-full-page-mask',
  templateUrl: './full-page-mask.component.html',
  styleUrls: ['./full-page-mask.component.scss']
})
export class FullPageMaskComponent {

  constructor(private fullPageMaskService: FullPageMaskService) { }

  get isVisible(): Observable<boolean> {
    return this.fullPageMaskService.isVisible;
  }

}
